export const secretHalfLast = "8eebb581c2b23de3";
